/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/



  const switchers = document.querySelectorAll('.language-switcher');
  const path = window.location.pathname;
  const isDE = path.startsWith('/de');

  // Set selected value for all switchers
  switchers.forEach(select => {
    select.value = isDE ? 'de' : 'en';

    select.addEventListener('change', () => {
      const selected = select.value;
      let newPath = path;

      if (selected === 'de' && !isDE) {
        newPath = '/de' + path;
      } else if (selected === 'en' && isDE) {
        newPath = path.replace(/^\/de/, '') || '/';
      }

      window.location.href = newPath + window.location.search;
    });
  });
